import memoize from "memoize";

import { cChromiaBalance } from "../../../classes/chromiaBalance";
import { cChromiaOption } from "../../../classes/chromiaOption";
import { iOption } from "../../../interfaces/interfaces";
import { eAppActionTypes } from "../../../store/app/appTypes";
import { eChromiaActionTypes } from "../../../store/chromia/chromiaTypes";
import { store } from "../../../store/store";
import { getActiveOptionsQuery, getAssetBalancesQuery, getClientOptionBalancesQuery, getClientOrdersQuery, getOptionByIdQuery, getOptionOrdersQuery } from "./queries";
import { cClientOrderOption } from "../../../classes/chromiaClientOrderOption";


/* export const getChrMainBalances = async (userAddress: string,) => {
	// console.log('get_chr_main_balances');

	store.getState().app.tokens.forEach(async (token) => {
		// const allAssets: any = await chrClient.query("ft4.get_all_assets", { page_size:10, page_cursor:null });
		// console.log('allAssets: ', allAssets.data.map((asset: any) => {return {...asset, id: asset.id.toString('hex')}}));

		const res = await getAssetBalanceQuery(userAddress, token.address);
		// console.log('res ' + token.currency + ': ', res);
		// console.log('res: ', new BigNumber(res?.amount.toString() || 0, {decimals: token.dec, currentDecimals: token.dec}) );

		store.dispatch({
			type: eChromiaActionTypes.SET_ASSET_BALANCE,
			payload: {
				asset: token.currency,
				// balance: new BigNumber(res?.amount.toString() || 0, {decimals: token.dec, currentDecimals: token.dec})
				balance: new cBigNumber(res?.amount.toString() || 0, {decimals: token.decimals, currentDecimals: token.decimals})
			}
		})
	})
} */

const availableTokens = ['USDT', 'BTC', 'ETH', 'CHR'];
export const getChrMainBalances = async (userAddress: string,) => {
	// const balances = (await getAssetBalancesQuery(userAddress)).filter(bal => bal.asset.currency.length < 30);	// temp
	const balances = (await getAssetBalancesQuery(userAddress)).filter(bal => availableTokens.includes(bal.asset.currency));	// temp
	store.dispatch({
		type: eChromiaActionTypes.SET_TOKEN_BALANCES,
		payload: balances
	})
}

export const updateActiveOptions = async () => {
	const options = await getActiveOptionsQuery();

	// const chrOptions: chromiaOption[] = [];
	// console.log('options: ', options.map(opt => {return {...opt.opt, ft: opt.opt.ft.toString('hex'), ut: opt.opt.ut.toString('hex')}}));
	//temp
	const filteredOptions = options/* .filter(opt =>
		opt.opt.ft.toString('hex').toLocaleLowerCase() === "ced37689d626e1238f7f9f750ce80e3f4a863aef2b4f7316e30ea6f2f8f57765" &&
		opt.opt.ut.toString('hex').toLocaleLowerCase() === "3fba5c5c160990e22f62bb16bb2388674ce553821a513007314251a78d52c4bb"
	); */
	const resOptions = filteredOptions.map(async option => new cChromiaOption(
		option.opt, await getOptionOrdersQuery(option.opt.id.toString('hex'))
	));

	const res = await Promise.all(resOptions);

	// options.forEach(async option => chrOptions.push(new ChromiaOption(option.opt, (await getOptionOrdersQuery(option.opt.id.toString('hex'))).map(ord => ord.ord))))
	// const option = new chromiaOption(options[0].opt, (await getOptionOrdersQuery(options[0].opt.id.toString('hex'))).map(ord => ord.ord))
	// const res = await getActiveOptionsBalancesQuery();

	// console.log('chrOptions: ', chrOptions);

	store.dispatch({
		type: eAppActionTypes.SET_CURRENT_OPTIONS,
		// payload: chrOptions
		payload: res
	})
}

export const updateClientOptions = async () => {

	const {clientBalances, currentOptions} = store.getState().app;

	const balances = (await getClientOptionBalancesQuery()).map(async balance => {
		const optId = balance.opt.toString('hex');

		/* return new ChromiaBalance({
			full_balance: balance.balance,
			locked_balance: balance.locked,
			exercise_balance: balance.exercised,
			created_balance: balance.created,
			borrow_balance: '0',
			opt_id: balance.option,
			opt: client_balances.find(balance => balance.opt_id === opt_id)?.opt || current_options.find(option => option.opt_id === opt_id) || getChrOptionById()
		}) */
		return new cChromiaBalance(
			balance,
			clientBalances.find(balance => balance.optId === optId)?.opt || currentOptions.find(option => option.optId === optId) || await getChrOptionById(optId)
		)
	});
	const res = await Promise.all(balances);
	// console.log('updateClientOptions: ', res);
	store.dispatch({
		type: eAppActionTypes.SET_CLIENT_BALANCES,
		payload: res
	})
}

/* export const updateClientOrders = async () => {
	const {clientBalances, currentOptions} = store.getState().app;
	const ordersRes = await getClientOrdersQuery();
	console.log('ordersRes: ', ordersRes);
	const orders = ordersRes.map(async order => {
		const optId = order.opt_id.toString('hex');

		return new cChromiaOrder(
			order,
			clientBalances.find(balance => balance.optId === optId)?.opt.uTokenCurrency || currentOptions.find(option => option.optId === optId)?.uTokenCurrency || (await getChrOptionById(optId)).uTokenCurrency
			// clientBalances.find(balance => balance.optId === optId)?.opt || currentOptions.find(option => option.optId === optId) || await getChrOptionById(optId)
		)
	});
	// console.log('client orders: ', orders);
	const res = await Promise.all(orders);

	store.dispatch({
		type: eAppActionTypes.SET_CLIENT_ORDERS,
		payload: res
	})
} */
export const updateClientOrders = async () => {
	const ordersRes = await getClientOrdersQuery();
	const { systemTimestamp } = store.getState().app;
	if (!systemTimestamp) throw new Error();	// ?
	// console.log('ordersRes: ', ordersRes);
	const orders = ordersRes.map(async order => {
		return new cClientOrderOption(await getOptionByIdQuery(order.opt_id.toString('hex')), order, systemTimestamp);
	});
	// console.log('client orders: ', orders);
	const res = await Promise.all(orders);

	store.dispatch({
		type: eAppActionTypes.SET_CLIENT_ORDERS,
		payload: res
	})
}

/**
 * Is memoization needed?
 */
export const getChrOptionById = memoize(async (id: string): Promise<iOption> => {
	// console.log('get option by id ', id);
	const { clientBalances, currentOptions } = store.getState().app;
	return clientBalances.find(balance => balance.optId === id)?.opt || currentOptions.find(option => option.optId === id) || new cChromiaOption( (await getOptionByIdQuery(id)), []);
})